/***
 * 
 * 指示清单
 * route.path   key指定相对组件名
 * item: {
 * path ：  路由path
 * name:  '唯一即可'
 * component： 组件实例
 * 
 * }
 */

import JiyunIndication from '@/components/indication/inner/JiyunIndication'


const indicationList = [{
  path: '/jiyun',
  name: 'JiyunIndication',
  component: JiyunIndication
}]

const components = {};
indicationList.forEach(e => {
  components[e.name] = e.component
})

const info = {}
indicationList.forEach(e => info[e.path] = false);
// 暴露路径给需要指引的配置
export const paths = info


import {
  loadTotal
} from '@/utils/indic'
export default { 
  mounted() {
    // localStorage.setItem('INDICATION_KEY', JSON.stringify(['/jiyun']));
    var unIndication = loadTotal()
    const keys = Object.keys(info)
    unIndication = unIndication.filter(e => keys.includes(e))
    if (unIndication.length) {
      this.$store.commit('indication/mergeLocal', unIndication)
    }

  },
  computed: {
    hasIndication() {
      const show = indicationList.find(e => e.path === this.$route.path) ? true : false;
      // console.log(show)
      return show

    },
    whichIndication() {
      // 指定组件名字
      const item = indicationList.find(e => e.path === this.$route.path);
      // console.log(item)
      return item ? item.name : "";
    }
  },
  components
}